var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.participantScores && _vm.scoreDef)?_c('div',{staticClass:"report-meter"},[_c('highcharts',{attrs:{"options":_vm.chartOptions}}),(_vm.label)?_c('div',{staticClass:"report-meter__meter-label"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }